import React from 'react';
import { Typography } from '@mui/material';
import {
	UserForContractSentEventFeed,
	getCustomerLinksAsVendorOrAPPAForContractEvent,
	DefaultEventProps,
} from './helpers';
// Lib
import { getDetailLink, linkObject } from '../../../lib/helpers';
import { LinkObjectType } from '../../../lib/helpers/types';

const getContractViewedEventProps = (
	eventProps: DefaultEventProps,
	user: UserForContractSentEventFeed
) => {
	if (
		!eventProps.event.contract ||
		typeof eventProps.event.contract === 'undefined'
	) {
		throw new Error( 'No contract provided' );
	}
	const { event } = eventProps;
	eventProps.icon = 'contract';
	eventProps.links = [
		{
			type: 'secondary',
			text: 'View',
			link: getDetailLink( {
				object: eventProps.event.contract,
				type: LinkObjectType.Contract,
			} ),
		},
	];
	eventProps.message = (
		<Typography>
			{ getCustomerLinksAsVendorOrAPPAForContractEvent( event, user, false ) } has
			viewed { linkObject( eventProps.event.contract ) }.
		</Typography>
	);
	return eventProps;
};

export default getContractViewedEventProps;
